// removed by extract-text-webpack-plugin
module.exports = {"contentIndex":"OYCpRI0KUafhh29u6SzSM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactsContent/index.css
// module id = 286
// module chunks = 0